export type MessageCatalog = Record<string, string>;
export type MessageParams = Record<string, string | number>;

type CreateTranslatorOptions = {
  locale?: string;
};

export function createTranslator(catalog: MessageCatalog, options: CreateTranslatorOptions = {}) {
  const pluralRules = new Intl.PluralRules(options.locale);

  return function t(key: string, params?: MessageParams) {
    const templateKey = resolveMessageKey(catalog, key, params, pluralRules);
    const template = catalog[templateKey] ?? key;
    if (!params) return template;
    return Object.entries(params).reduce(
      (message, [param, value]) => message.replaceAll(`{${param}}`, String(value)),
      template,
    );
  };
}

function resolveMessageKey(
  catalog: MessageCatalog,
  key: string,
  params: MessageParams | undefined,
  pluralRules: Intl.PluralRules,
) {
  if (typeof params?.count !== 'number') {
    return key;
  }

  const pluralKey = `${key}_${pluralRules.select(params.count)}`;
  if (pluralKey in catalog) {
    return pluralKey;
  }

  const fallbackPluralKey = `${key}_other`;
  return fallbackPluralKey in catalog ? fallbackPluralKey : key;
}
